import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentDefault({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <>{children}</>;
}
